import React, { FC, useEffect } from 'react';
interface Props {
	byId?: string;
}
export const IPOTipPop: FC<Props> = ({ byId }) => {
	useEffect(() => {
		try {
			init();
		} catch (e) {
			console.error('IPOTipPop', e);
		}
	}, []);

	const init = () => {
		const rootDom = document.getElementById(byId || 'root');
		if (rootDom) {
			rootDom.addEventListener('mouseover', () => {
				const allTag = document.querySelectorAll('*[alt-tip]');
				for (let i = 0; i < allTag.length; i++) {
					let itemDom = allTag[i];
					let titData = JSON.parse(itemDom.getAttribute('alt-tip') as string);
					let time: NodeJS.Timeout | null = null;
					itemDom.addEventListener('mouseover', () => {
						if (titData?.time) {
							if (!time) {
								time = setTimeout(() => {
									setView();
								}, 1000 * titData?.time);
							}
						} else {
							setView();
						}
						function setView() {
							const textDom = document.getElementById('alt-tip-text');
							const viewDom = document.getElementById('alt-tip-view');
							if (!textDom || !viewDom) return;
							textDom.innerHTML = titData.tit;
							viewDom.style.top =
								itemDom.getBoundingClientRect().top -
								textDom.clientHeight -
								5 +
								document.documentElement.scrollTop +
								'px';
							viewDom.style.left = itemDom.getBoundingClientRect().left + 'px';
							viewDom.style.display = 'block';
						}
					});
					itemDom.addEventListener('mouseleave', () => {
						time && clearTimeout(time);
						time = null;
						const viewDom = document.getElementById('alt-tip-view');
						if (viewDom) {
							viewDom.style.display = 'none';
						}
					});
				}
			});
		}
	};
	return (
		<div style={{ position: 'absolute', top: '0px', left: ' 0px', width: '100%' }}>
			<div>
				<div
					className="ant-tooltip ant-tooltip-placement-topLeft"
					id="alt-tip-view"
					style={{
						display: 'none',
						left: '100px',
						top: '200px',
						transformOrigin: '0px 52.3125px',
						pointerEvents: 'none'
					}}>
					<div className="ant-tooltip-content">
						<div className="ant-tooltip-arrow">
							<span className="ant-tooltip-arrow-content"></span>
						</div>
						<div id="alt-tip-text" className="ant-tooltip-inner" role="tooltip">
							hi
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
